import React, { useState, useEffect, useRef } from "react";
import WarningModal from "../components-modals/WarningModal";
import Layout from "../Layout";
import Container from "../components-layout/Container";
import Header from "../components-layout/Header";
import BusquedaAlumnos from "../tools/BusquedaAlumnos";
import { fetchApi } from "../tools";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  IdentificationIcon,
  ClipboardDocumentIcon,
  ChartBarIcon,
  CalendarIcon,
  DocumentChartBarIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { get } from "../usuarios/api/usuarios.api";
import {
  steps,
  solutions,
  campos,
  columnas,
  columnasSubmenu,
} from "./config/Columnas";
//import MenuSedes from "./components/MenuSedes";
import MenuSedes from "../pagos-administrativo/MenuSedes";
import { request } from "./tools/funciones";
import ResultadoDataGrid from "../tools/CustomDataGrid";

const RecepcionIndex = () => {
  const [modal, setModal] = useState({});
  const user = useSelector((state) => state.auth.user);
  const userObj = JSON.parse(user);
  const cookies = new Cookies();
  const url = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies
  const url2 = cookies.get("__urlInvoiceApi"); // url para enviar al api viene de cookies
  //const urlCursos = cookies.get("__urlCursosApi"); // url para enviar al api viene de cookies
  const urlSeguridadApi = cookies.get("__urlSeguridad");
  const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux
  const IdEmp = useSelector((state) => state.auth.IdEmp);
  const SedePref = useSelector((state) => state.auth.IdSede);
  const [showModalConfig, setShowModalConfig] = useState(false);
  const [papeleriaAlumno, setPapeleriaAlumno] = useState([]);
  const [tituloMenu, setTituloMenu] = useState();
  //////////////
  const [showEntrevistaAdmin, setEntrevistaAdmin] = useState(false);
  const [carnetResult, setCarnetResult] = useState([]);
  const [opcionSelect, setopcionSelect] = useState("");
  const [opcionSede, setopcionSede] = useState(SedePref);
  const [opcionCiclo, setopcionCiclo] = useState(2025);
  const [isGrid, setIsGrid] = useState(false);
  const [resetForm, setresetForm] = useState(false);
  const [flagSearch, setFlagSearch] = useState("Aspirante");
  const [textoBusqueda, setTextoBusqueda] = useState("");
  const [dataAlumnosBusqueda, setdataAlumnosBusqueda] = useState([]);
  const [showDialogoPlan4, setShowDialogoPlan4] = useState(false);
  const [alumnoSeleccionado, setAlumnoSeleccionado] = useState("");
  const [showPapeleria, setShowPapeleria] = useState(false);

  const excecuteModalIndex = (index, alumno) => {
    console.log(index, alumno);
  };

  //////////////

  const handleClick = async (dato, ciclo) => {

    setdataAlumnosBusqueda([]);
    let ciclos = 0;
    let Sede = "";

    switch (dato) {
      case "Calzada San Juan":
        Sede = "01";
        break;
      case "Avenida Petapa":
        Sede = "02";
        break;
      case "Aguilar Batres":
        Sede = "04";
        break;
      case "Zona 6":
        Sede = "05";
        break;
      case "San Cristóbal":
        Sede = "06";
        break;
      case "Villa Nueva":
        Sede = "07";
        break;
      case "El Naranjo":
        Sede = "08";
        break;
      case "Virtual a Distancia":
        Sede = "09";
        break;
      case "Amatitlán":
        Sede = "10";
        break;
      case "Jocotenango":
        Sede = "11";
        break;
      default:
        break;
    }

    if (ciclo.Actuales) {
      ciclos = 2023;
    } else {
      ciclos = 2021;
    }

    setopcionSede(Sede);

    if (textoBusqueda === "") {
      return;
    }
    if(!showPapeleria){
    let param = "";
    if (flagSearch === "Aspirante") {
      param = {
        opcion: "ALUMNOS_V2",
        Idsede: Sede,
        idciclo: ciclos,
        Aspirante: textoBusqueda,
      };
    } else {
      param = {
        opcion: "ALUMNOS_V2",
        Idsede: Sede,
        idciclo: ciclos,
        Carnet: textoBusqueda,
      };
    }

    try {
      const res = await fetchApi({
        url: url + "/utils/busquedas",
        headers,
        content: param,
      });

      if (res.length === 0) {
        //setdataAlumnos([]);
        setdataAlumnosBusqueda([]);
        setresetForm(false);
        setIsGrid(true);
      } else {
        setresetForm(false);
        setIsGrid(false);
        //dataAlumnosBusqueda(res);
        setdataAlumnosBusqueda(res);
      }
      console.log("alumnos: ", res);
    } catch (err) {
      console.log(err);
    }
  }
  };

  const handleEstadoCuenta = async (alumno) => {
    setShowPapeleria(true);
    setAlumnoSeleccionado(alumno);
    const datos = await request({
      contenido: { opcion: "PAPELERIAALUMNO", Carnet: alumno.Carnet },
      url: url + "/utils/busquedas",
      headers: headers,
    });
    let datosModificados = structuredClone(datos);
    datosModificados.forEach((e) => (e.Entregado = true));
    setPapeleriaAlumno(datosModificados);
  };

  const handleChangeSearch = (dato) => {
    setdataAlumnosBusqueda([]);
    setTextoBusqueda("");
    setFlagSearch(dato);
    setresetForm(true);
    setIsGrid(true);
  };

  const handleAlumnoCta = (...params) => {
    console.log(params); // selección de alumno
  };

  const handleSubmenu = (item, dato2, checked) => {
    let papeleriaCopia = [...papeleriaAlumno];
    papeleriaCopia.forEach((e) => {
      if (e.CodPapeleria === item.CodPapeleria) {
        e.Entregado = checked;
      }
      return e;
    });
    console.log("papeleriaCopia: ", papeleriaCopia);
    setPapeleriaAlumno(() => papeleriaCopia);
  };

  const [sedes, setSedes] = useState([]);
  const [obs, setObs] = useState("");

  function transformSedes(content) {
    let transformed = content;
    transformed.map((e) => {
      if (e.Iniciales === "Z7") {
        e.Iniciales = "SJ";
      }
      if (e.Iniciales === "Z12") {
        e.Iniciales = "PT";
      }
      if (e.Iniciales === "EN") {
        e.Iniciales = "NJ";
      }
      if (e.Iniciales === "VB") {
        e.Iniciales = "VD";
      }
      if (e.Iniciales === "AJ") {
        e.Iniciales = "JC";
      }
    });
    console.log(transformed);
    return transformed;
  }

  const loadSedes = async () => {
    try {
      const response = await get({
        url: url + "/utils/busquedas",
        opcion: { opcion: "SEDES" },
        headers: headers,
      });
      setSedes(transformSedes(response));
    } catch (error) {}
  };

  function porcentaje() {
    // let positivos = papeleriaAlumno.reduce((e, f) => e + (f.Entregado ?1:0),0)
    let b = papeleriaAlumno.reduce((e, f) => e + (f["Entregado"] ? 1 : 0), 0); //  / papeleriaAlumno.length * 100
    const total = b.toString() == "100" ? b : b.toString()[0] * 10;
    console.log(total);
    return total;
  }

  const save = async () => {
    let data = structuredClone(papeleriaAlumno);
    data.forEach((e) => {
      e.Entregado = e.Entregado ? 1 : 0;
      delete e.Orden;
      delete e.Documento;
      delete e.Responsable;
      return e;
    });
    let dataClean = { Detalle: data };
    const datos = await request({
      method: "POST",
      contenido: {
        Carnet: alumnoSeleccionado.Carnet,
        Papeleria: dataClean,
        Tipo: 1,
        Obs: obs,
        IdEmp: IdEmp,
      },
      url: url + "/tecnico/recepcion_papeleria",
      headers: headers,
    });

    if (datos.msg.Error === "0") {
      setShowPapeleria(false);
      setObs("");
      setModal({
        show: true,
        msg: datos.msg.Mensaje + " Id del Documento: " + datos.msg.IdDoc,
        ok: true,
      });
    } else {
      setModal({
        show: true,
        msg: "No se pudo guardar con éxito",
        ok: false,
      });
    }
  };

  useEffect(() => {
    setTextoBusqueda("")
    console.log('opcionSede: ', opcionSede)
    setShowPapeleria(false);
    setPapeleriaAlumno([]);
    setdataAlumnosBusqueda([]);
  }, [opcionSede])
  

  useEffect(() => {
    loadSedes();
  }, []);

  return (
    <>
      <WarningModal
        width={
          showModalConfig
            ? "xl:w-[50%] justify-center flex flex-col shadow-sm shadow-white"
            : "sm:w-full sm:max-w-sm"
        }
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            !showModalConfig ? (
              <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
            ) : null
          ) : !showModalConfig ? (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          ) : null
        }
        title={showModalConfig ? "Permisos de " + tituloMenu : "Aviso"}
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        <button
          onClick={() => {
            if (modal.reload) {
              window.location.reload();
            }
            setModal((curr) => ({
              ...curr,
              show: false,
              reload: false,
            }));
          }}
          type="button"
          className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
        >
          Entendido
        </button>{" "}
      </WarningModal>
      <Layout userObj={userObj} activeTab="Usuarios">
        <Container height="h-full">
          <Header title="Recepción de papelería" logo={ClipboardDocumentIcon} />

          <div className="bg-primarioMira px-4  rounded-md sm:p-6">
            {/* <div className="flex flex-row bg-red-500"> */}
            <div className="divide-grisMira rounded-md h-30 w-full mx-auto justify-center bg-secundarioMira shadow-sm shadow-grisMira p-2">
              {/* <p className="block text-sm font-medium text-grisMira bg-secundarioMira px-2 py-2">Secciona un campus</p> */}
              {/* <MenuSedes
                pasos={steps}
                solutions={solutions}
                handleClick={handleClick}
                Sede={opcionSede}
                handleChangeSearch={handleChangeSearch}
                sedes={sedes}
                sede={sede}
                handleSede={handleSede}
              ></MenuSedes> */}
              <MenuSedes
                pasos={steps}
                solutions={solutions}
                handleClick={handleClick}
                Sede={opcionSede}
                handleChangeSearch={handleChangeSearch}
                orientacion="start"
              ></MenuSedes>
            </div>
            <div className="mt-2 grid grid-cols-4 bg-secundarioMira /shadow-md shadow-grisMira rounded-md">
              <div className="px-2 py-2 col-span-full lg:col-start-1 lg:col-end-6 bg-secundarioMira shadow-md shadow-grisMira rounded-md">
                {showPapeleria ? (
                  <>
                    <div className="text-white flex flex-col p-4">
                      <p className="font-bold text-2xl mb-4">
                        {alumnoSeleccionado.NombreCompleto}
                      </p>
                      <div className="flex flex-row gap-6">
                        <div className="flex flex-col gap-2 text-gray-400 text-sm">
                          <IdentificationIcon className="h-6 w-6 mx-auto"></IdentificationIcon>{" "}
                          <p className="-font-bold my-auto">
                            {alumnoSeleccionado.Carnet}
                          </p>
                        </div>
                        <div className="flex flex-col gap-2 text-gray-400 ">
                          <ChartBarIcon className="h-6 w-6 mx-auto"></ChartBarIcon>{" "}
                          <p className="my-auto">{alumnoSeleccionado.Grado}</p>
                        </div>
                        <div className="flex flex-col gap-2 text-gray-400 ">
                          <CalendarIcon className="h-6 w-6 mx-auto"></CalendarIcon>{" "}
                          <p className="my-auto">
                            Ciclo {alumnoSeleccionado.Ciclo}
                          </p>
                        </div>
                        <div className="flex flex-col gap-2 text-gray-400 ">
                          <DocumentChartBarIcon className="h-6 w-6 mx-auto"></DocumentChartBarIcon>{" "}
                          <p className="my-auto">
                            Plan {alumnoSeleccionado.PlanE}
                          </p>
                        </div>
                        <div className="flex flex-col gap-2 text-gray-400 ">
                          <BuildingOfficeIcon className="h-6 w-6 mx-auto"></BuildingOfficeIcon>{" "}
                          <p className="-font-bold my-auto">
                            {alumnoSeleccionado.Sede}
                          </p>
                        </div>
                      </div>
                      <div className="hidden /flex flex-row">
                        <div className="w-1/2 h-10 bg-gray-400 rounded-md p-1">
                          <div
                            className={`bg-blueGray-100 w-[${porcentaje()}%] h-8 my-auto rounded-md`}
                          ></div>
                          {porcentaje()}
                        </div>
                      </div>
                    </div>
                    {papeleriaAlumno.length > 0 ? (
                      <>
                        <ResultadoDataGrid
                          alumnos={papeleriaAlumno}
                          seleccion={true}
                          columnas={columnasSubmenu} 
                          handleAlumno={handleSubmenu}
                        />
                        <div className="flex flex-col p-4 gap-4">
                          <p className="text-white font-medium text-xl">
                            Comentarios
                          </p>
                          <textarea
                            name="docAdicionales"
                            rows="3"
                            maxLength={115}
                            value={obs}
                            onChange={(e) => setObs(e.target.value)}
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm 
                        focus:border-secundario focus:ring-secundario sm:text-sm"
                          ></textarea>
                          <p className="text-white">{obs?.length} / 115</p>
                        </div>
                      </>
                    ) : (
                      <div className="p-4 w-full flex flex-row justify-center gap-2 elementFadeIn">
                        <ExclamationCircleIcon className="w-10 h-10 text-secundario my-auto"></ExclamationCircleIcon>
                        <p className="my-auto text-2xl text-white font-medium">
                          Sin información disponible
                        </p>
                      </div>
                    )}
                    <div className="flex flex-row justify-between px-4 pb-4 rounded-md">
                      <button
                        onClick={() => {setShowPapeleria(false); setObs("")}}
                        className="bg-azulBrillanteMira px-4 py-2 rounded-md text-white | shadow-white hover:cursor-pinter hover:shadow-md"
                      >
                        Cancelar
                      </button>
                      {papeleriaAlumno.length > 0 && (
                        <button
                          onClick={() => save()}
                          className="bg-azulBrillanteMira px-4 py-2 rounded-md text-white | shadow-white hover:cursor-pinter hover:shadow-md"
                        >
                          Guardar
                        </button>
                      )}
                    </div>
                  </>
                ) : (
                  <BusquedaAlumnos
                    url={url + "/utils/busquedas"}
                    headers={headers}
                    setModal={setModal}
                    setClose={setEntrevistaAdmin}
                    setResponse={setCarnetResult}
                    metodo={"ALUMNOS_V2"}
                    opcion={"opcion"}
                    campos={campos}
                    columnas={columnas}
                    titulo={"Resultados"}
                    subtitulo={"Listado que coinciden con tu búsqueda"}
                    seleccion={true}
                    setopcionSelect={setopcionSelect}
                    reg_pag={20}
                    Idsede={"Idsede"}
                    Sede={opcionSede}
                    IdCiclo={opcionCiclo} // pendiente
                    handleAlumnoCta={handleAlumnoCta}
                    dataAlumnos={dataAlumnosBusqueda}
                    setTextoBusqueda={setTextoBusqueda}
                    flagSearch={flagSearch}
                    resetSearch={resetForm}
                    setresetForm={setresetForm}
                    isGrid={isGrid}
                    setIsGrid={setIsGrid}
                    showDialogoPlan4={showDialogoPlan4}
                    setEstado={excecuteModalIndex}
                    mainURL={url}
                    handleClick={handleEstadoCuenta}
                  />
                )}
              </div>
            </div>
          </div>
        </Container>
      </Layout>
    </>
  );
};

export default RecepcionIndex;
